import { render } from "./PccApplicationType.vue?vue&type=template&id=6bb1e0c2"
import script from "./PccApplicationType.vue?vue&type=script&lang=js"
export * from "./PccApplicationType.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__